// extracted by mini-css-extract-plugin
module.exports = {"bannerComponent":"qa","red":"ra","calloutlink":"sa","headerTopBanner":"ta","bgcolorRed":"ua","headerTopCallout":"va","searchBanner":"wa","hideMobile":"xa"};